import React from "react";
import { toast } from "react-toastify";

// Browsers only allow window.open for a few seconds after a click, so PDF generation
// that opens the result afterwards gets popup-blocked silently on slow requests.
// Open the tab synchronously in the click handler instead, then point it at the PDF
// once it is ready. If the tab could not be opened at all, fall back to a toast with
// a clickable link (a direct link click is never popup-blocked).
export function openPdfWindow() {
    const pdfWindow = window.open("", "_blank");

    if (pdfWindow) {
        pdfWindow.document.write(
            '<title>Generating PDF</title><body style="font-family: sans-serif; padding: 40px; color: #444;">Generating PDF, please wait...</body>'
        );
    }

    return {
        show(url) {
            if (pdfWindow && !pdfWindow.closed) {
                pdfWindow.location.href = url;
            } else {
                toast.info(
                    <a href={url} target="_blank" rel="noopener noreferrer">
                        Your PDF is ready &mdash; click here to open it
                    </a>,
                    { autoClose: false }
                );
            }
        },
        close() {
            if (pdfWindow && !pdfWindow.closed) {
                pdfWindow.close();
            }
        },
    };
}
